import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    create: 'Create',
    creationTitle: 'Create a wallet',
    errors: {
      maxLengthExceeded:
        'Maximum length exceeded. Please limit to 30 characters.',
      nameAlreadyExists: 'You already used this name. Try another.',
      onlyLettersNumbers:
        'You can only enter letters, numbers, periods, and spaces here.',
      required: 'Enter a name to create the wallet',
    },
    name: 'Name of your wallet',
    placeholder: 'Enter the name here',
    placeholders: ['Salary', 'Urssaf', 'VAT'],
    update: 'Save',
    updateTitle: 'Edit wallet',
  },
  fr: {
    create: 'Créer',
    creationTitle: 'Créer un sous-compte',
    errors: {
      maxLengthExceeded:
        'Longueur maximale dépassée. Veuillez limiter à 30 caractères.',
      nameAlreadyExists: 'Nom déjà utilisé. Essayez un autre nom.',
      onlyLettersNumbers:
        'Vous ne pouvez entrer que des lettres, des chiffres, des points et des espaces ici.',
      required: 'Saisissez un nom pour créer le compte',
    },
    name: 'Nom de votre sous-compte',
    placeholder: 'Saisissez le nom ici',
    placeholders: ['Salaires', 'Urssaf', 'TVA'],
    update: 'Enregistrer',
    updateTitle: 'Modifier le compte',
  },
} as const);

export default locales;
